import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    csCountries: [],
    csStep1Data: {},
    csStep2Data: {},
    step1Done: false,
    step2Done: false,
    csOrderID: '',
    csBancontactSource: {}
  },
  getters: {
    getCsCountries: state => {
      return state.csCountries;
    },
    getCsStep1Data: state => {
      return state.csStep1Data;
    },
    getCsStep2Data: state => {
      return state.csStep2Data;
    },
    getStep1Done: state => {
      return state.step1Done;
    },
    getStep2Done: state => {
      return state.step2Done;
    },
    getCsOrderId: state => {
      return state.csOrderID;
    },
    getCsBancontactSource: state => {
      return state.csBancontactSource;
    }
  },
  mutations: {
    updateCsCountries: (state, payload) => {
      state.csCountries = payload;
    },
    updateCsStep1Data: (state, payload) => {
      state.csStep1Data = payload;
    },
    updateCsStep2Data: (state, payload) => {
      state.csStep2Data = payload;
    },
    updateStep1Done: (state, payload) => {
      state.step1Done = payload;
    },
    updateStep2Done: (state, payload) => {
      state.step2Done = payload;
    },
    updateCsOrderId: (state, payload) => {
      state.csOrderID = payload;
    },
    updateCsBancontactSource: (state, payload) => {
      state.csBancontactSource = payload;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js